import React from "react";
import "./Categories.css";

function Categories({ filter, categories }) {
  const displayCategories = categories.map((cat, i) => {
    return (
      <button key={i} onClick={() => filter(cat)} className="btn-port">
        {cat}
      </button>
    );
  });
  return <div className="buttons">{displayCategories}</div>;
}

export default Categories;
